import React,{useEffect} from "react";
import { Dialog, DialogContent, Typography, Box, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SuccessMessage = ({  title, message,open, onClose }) => {
    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000); // Close dialog after 3 seconds

            return () => clearTimeout(timer); // Cleanup timeout if component unmounts or open changes
        }
    }, [open, onClose]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                    padding: "20px",
                    textAlign: "center",
                    position: "relative", // Add relative positioning for the dialog
                    overflow: "visible", // Allow overflow
                },
            }}
        >
            {/* Box with Shimmer Effect */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-60px", // Position it above the dialog
                    left: "50%",
                    transform: "translateX(-50%)", // Center horizontally
                    backgroundColor: "var(--primary-color-light)",
                    borderRadius: "50%",
                    width: "120px",
                    height: "120px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    animation: "shimmer 2s infinite",
                    "@keyframes shimmer": {
                        "0%": {
                            boxShadow:
                                "0 0 10px var(--primary-color-light), 0 0 20px var(--primary-color-light)",
                        },
                        "50%": {
                            boxShadow:
                                "0 0 20px var(--primary-color), 0 0 30px var(--primary-color-light)",
                        },
                        "100%": {
                            boxShadow:
                                "0 0 10px var(--primary-color-light), 0 0 20px var(--primary-color-light)",
                        },
                    },
                }}
            >
                <CheckCircleIcon sx={{ color: "white", fontSize: "48px" }} />
            </Box>

            {/* Main Content */}
            <DialogContent sx={{ mt: "60px" }}> {/* Adjust margin-top for spacing */}
                <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", marginBottom: "8px" }}
                >
                     {title || "Success"}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ color: "#6b6b6b", marginBottom: "16px" }}
                >
                          {message || "Your action was successful!"}
                </Typography>
                <Button
                    variant="contained"
                    onClick={onClose}
                    sx={{
                        backgroundColor: "var(--primary-color)",
                        "&:hover": {
                            backgroundColor: "var(--primary-color-dark)",
                        },
                        textTransform: "none",
                    }}
                >
                    Close
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default SuccessMessage;
